import { memo, useCallback } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import { useNavigate } from 'react-router-dom';
import { getKindIcon, getKindColor } from '../../../../shared/constants';
import type { EntityNodeData } from '../../hooks/entity-graph.hook';
import { onKeyActivate } from '../../../../shared/utils';
import styles from './entity-node.module.css';

export const EntityNode = memo(({ data }: NodeProps) => {
  const navigate = useNavigate();
  const nodeData = data as unknown as EntityNodeData;
  const { label, kind, namespace, isCurrent } = nodeData;
  const Icon = getKindIcon(kind);
  const color = getKindColor(kind);

  const handleClick = useCallback(() => {
    navigate(`/catalog/${namespace}/${kind.toLowerCase()}/${label}`);
  }, [navigate, namespace, kind, label]);

  return (
    <div
      onClick={handleClick}
      onKeyDown={onKeyActivate(handleClick)}
      role="button"
      tabIndex={0}
      className={`${styles.node}${isCurrent ? ` ${styles.nodeCurrent}` : ''}`}
    >
      <Handle id="top-src" type="source" position={Position.Top} className={styles.handle} />
      <Handle id="top-tgt" type="target" position={Position.Top} className={styles.handle} />
      <Handle id="bottom-src" type="source" position={Position.Bottom} className={styles.handle} />
      <Handle id="bottom-tgt" type="target" position={Position.Bottom} className={styles.handle} />
      <Handle id="left-src" type="source" position={Position.Left} className={styles.handle} />
      <Handle id="left-tgt" type="target" position={Position.Left} className={styles.handle} />
      <Handle id="right-src" type="source" position={Position.Right} className={styles.handle} />
      <Handle id="right-tgt" type="target" position={Position.Right} className={styles.handle} />
      <span className={styles.kindLabel} style={{ color }}>
        <Icon size={16} />
        {kind}
      </span>
      <span className={styles.nameLabel}>
        {label}
      </span>
    </div>
  );
});

EntityNode.displayName = 'EntityNode';
